import { useEffect, useRef, useState } from "react";
import { style } from "./StyleType";
import TmpIconCustom from "../TmpIconCustom/TmpIconCustom";
import { ReactComponent as IconInfo } from "../../../assets/icons/info.svg";
import { ReactComponent as IconError } from "../../../assets/icons/erro.svg";
import { FormControl, Helper, InputContainer, InputSearch, Label, OptionsList, Select, SelectButton, StyledSpinner } from "./Style";
import Chevron from "./Chevron";
import SelectHelper from "../../../helpers/Selects/SelectHelper";
import { axiosBasic } from "../../../config/axios-common";
import OptionItemTyped from "../../../models/OptionItemTyped";
import TmpListItemCustom from "../TmpListItemCustom/TmpListItemCustom";

interface TmpInputSelectSearchAPICustomProps<T> {
    id: string;
    label: string;
    name: string;
    placeholder: string;
    urlAPI: string;
    maxLength?: number;
    value: OptionItemTyped<T> | undefined;
    helperIcon?: "info" | "error";
    helperText?: string;
    error?: boolean;
    disabled?: boolean;
    onChange: (value: OptionItemTyped<T>) => void;
    onBlur?: (value: OptionItemTyped<T>) => void;
}


export default function TmpInputSelectSearchAPICustom<T>(props: TmpInputSelectSearchAPICustomProps<T>) {

    const [_inputOpened, setInputOpened] = useState(false);
    const [_value, setValue] = useState<OptionItemTyped<T> | undefined>(props.value);
    const ref = useRef<HTMLInputElement>(null);
    const labelId = `${props.id}-label`;
    const [_textSearch, setTextSearch] = useState<string>("");
    const [_itens, setItens] = useState<OptionItemTyped<T>[]>();
    const [timeoutId, setTimeoutId] = useState<any | undefined>(undefined);
    const [loading, setLoading] = useState<boolean>(false);

    const handleClickOutside = (event: any) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setInputOpened(false);
        }
    };

    useEffect(() => {
        if (props.value !== undefined && props.value !== null && props.value.Text !== "" && props.value.Text !== undefined) {
            setTextSearch(props.value.Text);

            if(_itens === undefined || _itens === null || _itens.length === 0){
                setItens(SelectHelper.CreateOptionsFromOptionTyped(props.value));
            }else{
                var index = SelectHelper.GetIndex(props.value, _itens);
                if(index === -1){
                    setItens(SelectHelper.CreateOptionsFromOptionTyped(props.value));
                }
            }
        } else {
            setTextSearch("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value]);

    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true);
        return () => {
            document.removeEventListener("click", handleClickOutside, true);
        };
    });

    const _handleClick = () => {
        if (props.disabled) return;

        // setTimeout(() => {
        //     if (!_inputOpened) {
        //         // const itemIndex = SelectHelper.GetIndex(_value, props.itens);
        //         // if (document !== null && itemIndex > 0) {
        //         //     let item = document.getElementById(`${props.id}-${itemIndex}`);
        //         //     if (item !== null) {
        //         //         item.focus();
        //         //     }
        //         // }
        //     }
        // }, 100);
        setInputOpened(!_inputOpened);
    };

    const _handleChange = (item: OptionItemTyped<T>) => {
        props.onChange(item)
        setValue(item);
        setTextSearch(item.Text);
    };

    const handleListItemKeyDown = (event: any, index: number) => {
        switch (event.key) {
            case "Tab":
                setInputOpened(false);
                break;

            case "ArrowUp":
                event.preventDefault();
                const prevIndex = index > 0 ? index - 1 : index;
                if (document !== null) {
                    let item = document.getElementById(`${props.id}-${prevIndex}`);
                    if (item !== null) {
                        item.focus();
                    }
                }
                break;

            case "ArrowDown":
                event.preventDefault();
                // const nextIndex = index < props.itens.length - 1 ? index + 1 : index;
                // if (document !== null) {
                //     let item = document.getElementById(`${props.id}-${nextIndex}`);
                //     if (item !== null) {
                //         item.focus();
                //     }
                // }
                break;

            case "Enter":
                setInputOpened(false);
                //_handleChange(props.itens[index]);
                if (document !== null) {
                    let item = document.getElementById(props.id);
                    if (item !== null) {
                        item.focus();
                    }
                }
                break;

            default:
                break;
        }
    };

    const handleInputChange = (e: any) => {
        setTextSearch(e.target.value);
        setInputOpened(true);
        // setItens(SelectHelper.FilterOptions(e.target.value, _itensAux));

        const value = e.target.value;
        setTextSearch(value);

        // Usando o debounce com um atraso de 300 milissegundos
        clearTimeout(timeoutId);

        const idTimeOut = setTimeout(() => {
            debouncedSearch(value);
        }, 300);

        setTimeoutId(idTimeOut);
    };

    const debouncedSearch = (value: string): void => {


        setLoading(true);

        // Coloque sua chamada à API usando o Axios aqui
        axiosBasic.get(`${props.urlAPI}${value}`)
            .then(response => {

                var result = new Array<OptionItemTyped<T>>();

                if (response.data !== undefined && response.data.length > 0) {

                    result = response.data.map((row: any) => {
                        let item = OptionItemTyped.NewInstance();

                        item.Id = row.id;
                        item.Text = row.description;
                        item.Caption = row.caption;

                        const newRow: any = {};

                        for (const key in row) {
                            if (row.hasOwnProperty(key)) {
                                const newKey = key.charAt(0).toUpperCase() + key.slice(1);
                                newRow[newKey] = row[key];
                            }
                        }

                        item.Value = newRow;


                        return item;
                    });
                }

                setItens(result);
                setLoading(false);

            })
            .catch(error => {
                setLoading(false);
                console.error(error);
            });

    };

    //OBS: Método usando apenas para renderizar a mensagem de erro ao passar pelo campo. A seleção do campo dispara o evento de OnChange (handleAutocompleteChange)
    const handleOnBlurChange = (newValue: any) => {
        if (props.onBlur && newValue.target.value === "") {
            props.onBlur(newValue.target.value)
            setValue(newValue.target.value)
        }
    };

    // Passing style props to styled component
    FormControl.defaultProps = style;
    Label.defaultProps = style;
    Select.defaultProps = style;
    SelectButton.defaultProps = style;
    OptionsList.defaultProps = style;
    Helper.defaultProps = style;

    return (
        <>
            <FormControl
                actived={_inputOpened}
                onClick={_handleClick}
                onBlur={handleOnBlurChange}
                error={props.error ? true : false}
                selected={true}
                disabled={props.disabled ? true : false}
            >
                <Label htmlFor={props.id} id={labelId} className="tmp-select__label">
                    {props.label}
                </Label>

                <Select data-testid="select" ref={ref}>
                    <SelectButton type="button" id={`${props.id}-button`}>
                        <InputContainer>
                            <InputSearch
                                autoComplete="off"
                                disabled={props.disabled}
                                onClick={_handleClick}
                                onChange={handleInputChange}
                                name={`input-${props.name}`}
                                value={_textSearch}
                                placeholder={props.placeholder}
                                type="text" />
                            {loading ?
                                <span className="loading-container">
                                    <StyledSpinner viewBox="0 0 50 50">
                                        <circle
                                            className="path"
                                            cx="25"
                                            cy="25"
                                            r="20"
                                            fill="none"
                                            strokeWidth="5"
                                        />
                                    </StyledSpinner>
                                </span>
                                : null}
                            <span className="chevron-container">
                                <TmpIconCustom size="sm" icon={<Chevron />} />
                            </span>
                        </InputContainer>
                    </SelectButton>

                    <OptionsList
                        id={props.id}
                        actived={_inputOpened}
                        value={(_value !== undefined && _value !== null ? _value.Text : null)}
                        disabled={props.disabled ? true : false}
                        role="listbox"
                        aria-labelledby={labelId}
                    >
                        {_itens !== undefined && _itens.map((item, index) => (
                            <TmpListItemCustom
                                id={`${props.id}-${index}`}
                                key={index}
                                label={item.Text}
                                text={item.Caption}
                                role="option"
                                tabIndex={index === 0 ? 0 : -1}
                                handleClick={() => _handleChange(item)}
                                keyDown={(e: any) => { handleListItemKeyDown(e, index); }}
                            />
                        ))}

                        {(_itens === undefined || _itens.length === 0) ?
                            <TmpListItemCustom
                                id={`-1-not-fount-${props.id}`}
                                key={-1}
                                label={"Resultado não encontrado"}
                                role="option"
                            />
                            : null
                        }
                    </OptionsList>
                </Select>

                <Helper >
                    {props.helperIcon === "error" && props.error &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconError />} />
                        </span>
                    }
                    {props.helperIcon === "info" &&
                        <span className="icon">
                            <TmpIconCustom size="sm" icon={<IconInfo />} />
                        </span>
                    }
                    {props.helperText}

                </Helper>
            </FormControl>
        </>
    );
}


